import { FC } from 'react'
import Swiper from 'swiper'
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react'
import { t } from 'i18next'
import InteractionBase from '../../../common/components/InteractionBase'
import styles from './FeedbackPost.module.css'
import Slider from '../../../common/components/Slider'
import { useFeedStore } from '../../../store/feed-store'
import StepsNavigation from '../../../common/components/InteractionBase/StepsNavigation'
import { authFetch } from '../../../common/utils/cognito'
import { useUserStore } from '../../../store/user-store'

interface FeedbackPostProps {}

const FeedbackPost: FC<FeedbackPostProps> = () => {
  const { setCurrentStep } = useFeedStore()
  const { fetchUser } = useUserStore()

  const onChange = async (rating: number) => {
    const response = await authFetch(`${process.env.REACT_APP_API_URL}/me`, {
      method: 'PATCH',
      body: JSON.stringify({
        appRating: rating + 1,
      }),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    await fetchUser()
  }

  const handleSlideChange = (swiper: Swiper) => {
    setCurrentStep(swiper.activeIndex + 1)
  }

  return (
    <ReactSwiper
      style={{ height: '100dvh', position: 'relative' }}
      spaceBetween={30}
      keyboard
      onSlideChange={handleSlideChange}
      watchSlidesProgress
    >
      <StepsNavigation numberOfSteps={2} />
      <SwiperSlide style={{ height: '100%' }}>
        <InteractionBase
          title={t('feedback.title')}
          hasStepDisplay
          hideSubtitle
        >
          <div className={styles.container}>
            <div>
              <h3>{t('feedback.ratingQuestion')}</h3>
              <Slider
                labels={['😭', '🙁', '😐', '🙂', '😍']}
                labelStyle={{ fontSize: '2rem' }}
                onChange={onChange}
                sliderValue={2}
              />
            </div>
          </div>
        </InteractionBase>
      </SwiperSlide>
      <SwiperSlide style={{ height: '100%' }}>
        <InteractionBase
          title={t('feedback.title')}
          hasStepDisplay
          hideSubtitle
        >
          <div className={styles.container}>
            <div>
              <h3>{t('feedback.formQuestion')}</h3>
              <a href={t('feedback.link')} target="_blank" rel="noreferrer">
                {t('feedback.buttonText')}
              </a>
            </div>
          </div>
        </InteractionBase>
      </SwiperSlide>
    </ReactSwiper>
  )
}

export default FeedbackPost
